import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from '../../../core/guards/auth.service';
import { AlertService } from '../../shared/alert/alert.service';
import { AppService } from '../../../app.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-navigationlink',
  standalone: true,
  imports: [CommonModule, RouterModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    MatListModule,
    CommonModule,
    MatTableModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatPaginatorModule,
    MatSortModule,
  ],
  templateUrl: './navigationlink.component.html',
  styleUrl: './navigationlink.component.scss'
})
export class NavigationlinkComponent {

  breadcrumb: string[] = [];
  visitedRoutes: string[] = [];

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private service: AuthService,
    private alertService: AlertService,
    private commonService: AppService) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      let currentRoute = this.activatedRoute.root;
      this.breadcrumb = this.getBreadcrumb(currentRoute);
      this.addVisitedRoute(this.breadcrumb.join(' >> '));
    });
    this.commonService.cadStatusData$.subscribe(res => {
      this.roleName = localStorage.getItem('roles')
      if (res && this.roleName == 'Client') {
        this.isImpersonate = true
        this.roleName = localStorage.getItem('roles')
        // this.reloadComponent2()
      } else {
        this.isImpersonate = false

      }
    })
  }
  roleName: any
  showLink: boolean = false
  isImpersonate = false
  ngOnInit() {
    this.roleName = localStorage.getItem('roles')
    let rawdata: any = localStorage.getItem('isImpersonated')
    this.isImpersonate = JSON.parse(rawdata)
    if (this.roleName == 'Client') {
      this.showLink == true
    }
    //   this.router.events.pipe(
    //     filter(event => event instanceof NavigationEnd)
    //   ).subscribe(() => {
    //     let currentRoute = this.activatedRoute.root;
    //     this.breadcrumb = this.getBreadcrumb(currentRoute);
    //     this.addVisitedRoute(this.breadcrumb.join(' >> ')); 
    //   });
  }

  getBreadcrumb(route: ActivatedRoute | null): string[] {
    const breadcrumb: string[] = [];
    while (route) {
      if (route.snapshot?.data['breadcrumb']) {
        breadcrumb.push(route.snapshot.data['breadcrumb']);
      }
      route = route.firstChild;
    }
    return breadcrumb;
  }



  addVisitedRoute(route: string): void {
    if (route == "User Settings" || route == "Dashboard" || route == "Template") {
      this.visitedRoutes = [route];
      return
    }
    if ((this.visitedRoutes.length > 1 && !this.visitedRoutes.includes(route)) || route != "User Settings") {
      this.visitedRoutes.push(route);;
    }
  }
  // addVisitedRoute(route: string): void {
  //   if (!this.visitedRoutes.includes(route)) {
  //     this.visitedRoutes.push(route);
  //   }
  // }



  getRoutePath(route: any) {
    if (route == '"User Settings >> User Settings"') {
      this.router.navigate(['usersettings'])
      this.visitedRoutes = []

    }
    if (route == '"Template >> Template"') {
      this.router.navigate(['template'])
      this.visitedRoutes = []

    }
  }
  loginData: any
  isLogin: boolean = false

  backToAccountM() {
    this.service.backToAM(localStorage.getItem('userID')).subscribe(response => {
      this.loginData = response
      localStorage.setItem('services', response.accessUser)
      localStorage.setItem('services', response.services)
      localStorage.setItem('roles', response.roles)
      localStorage.setItem('userName', response.userName)
      // this.commonservice.userDetails.next(response.roles)
      localStorage.setItem('authToken', response.token);
      localStorage.setItem('appUserID', response.appUserID);
      this.isLogin = true
      this.commonService.cadStatusData.next(this.isLogin)
      this.commonService.loginData.next(this.loginData)
      this.alertService.success("User logged in successfully")
      this.reloadComponent2()
    })
  }
  reloadComponent2() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['smartdocs/folders']);
    });
  }
}
